import LogRocket from "logrocket";
import setupLogRocketReact from "logrocket-react";

setupLogRocketReact(LogRocket);

if (process.env.REACT_APP_ENV !== "dev") {
  LogRocket.init("fyqxo2/artist-portal");
}
